module.exports = __webpack_public_path__ + "img/chateaulaval.dcb14683.jpg";